<template>
  <h2
    class="otb-summary__license-warning-message"
    :class="warningMessageClass"
    v-html="message"
  ></h2>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import { TranslateResult } from 'vue-i18n';

import { useMediaQuery } from '../../../../composables/media-query.composable';

export default defineComponent({
  name: 'otb-summary-license-warning',
  props: {
    message: String as () => string | TranslateResult,
  },
  setup() {
    const { isMobile } = useMediaQuery();

    const warningMessageClass = computed(() => {
      return isMobile.value ? 'wb-type-copy-strong' : 'wb-type-heading-xs';
    });

    return {
      warningMessageClass,
    };
  },
});
</script>
<style lang="scss" src="./summary-license-warning.scss"></style>
